module.exports = __webpack_public_path__ + "img/ninja1.4929c54e.png";